module.exports = __webpack_public_path__ + "static/normal-prostate-9a2cd54e0c9f22d4a85f798f89f6d6d2.svg";